var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-row",
        { staticStyle: { "margin-left": "0px" }, attrs: { gutter: 20 } },
        _vm._l(_vm.deliveryPlatform, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              class: {
                "border delivery-block hover-color": true,
                active: item.active,
              },
              style: {
                cursor: item.error ? "not-allowed" : "pointer",
                color: item.error ? "#909399" : "#262626",
                float: "left",
              },
              on: {
                click: function ($event) {
                  return _vm.selectDelivery(item)
                },
              },
            },
            [
              _c("div", [_vm._v(_vm._s(item.name))]),
              _c("div", { staticStyle: { "line-height": "14px" } }, [
                _vm._v(
                  _vm._s(item.amount) + _vm._s(item.error ? item.remarks : "元")
                ),
              ]),
            ]
          )
        }),
        0
      ),
      _c(
        "el-row",
        {
          staticStyle: { "margin-top": "10px" },
          attrs: { type: "flex", justify: "end" },
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", plain: "" },
              on: { click: _vm.onClose },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.sendDelivery } },
            [_vm._v("确 认")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }